import { msg } from "../locales/translate";
import { DataProvider } from "badmfck-signal";
import { IExecutorResponse } from "badmfck-signal/dist/DataProvider";
import { GD } from "src/GD";


export class BanksService {
	static ssid =
		"7cf3ed1c12fdb3a57e3158923f472d5c71af9b51b4809f71ff07d449bed871a0";

	banks: DataProvider<{ projectID: number }, IBank[]> = new DataProvider(
		{ cacheTime: 0 },
		"Banks"
	);

	constructor() {
		this.banks.setExecutor(
			async () =>
				(await GD.REQ_API.request({
					method: "bank/list",
					data: {
						project_id: (
							await GD.REQ_CURRENT_PROJECT.request()
						)?.id,
					},
				})) as IExecutorResponse<IBank[]>
		);

		GD.REQ_BANK.listener = async req => this.getBank(req);
		GD.REQ_BANK_SAVE.listener = async req => this.saveBank(req);
		GD.REQ_BANK_DELETE.listener = async req => this.deleteBank(req);
		GD.REQ_BANK_RESTORE.listener = async req => this.restoreBank(req);
		GD.B_BANKS.onRequest(async () =>
			GD.B_BANKS.invoke(await this.banks.load())
		);
	}

	async restoreBank(req: number): Promise<IAPIResponse<IBank>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		res = await GD.REQ_API.request({
			method: "bank/restore",
			data: {
				id: req,
			},
		});

		if (res && !res.error) {
			this.banks.reset();
			GD.B_BANKS.invoke(await this.banks.load());
			//  GD.REQ_ACQUIRER.request({acquirerID:req.id})
		}
		return res;
	}

	async deleteBank(req: number): Promise<IAPIResponse<IBank>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		res = await GD.REQ_API.request({
			method: "bank/delete",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				id: req,
			},
		});

		if (res && !res.error) {
			this.banks.reset();
			GD.B_BANKS.invoke(await this.banks.load());
			//  GD.REQ_ACQUIRER.request({acquirerID:req.id})
		}
		return res;
	}

	generateNewBank(): IBank {
		const res: IBank = {
			data: {
				country: "",
				iban: [],
				name: "",
				timezone: 0,
			},
			status: "active",
			id: -1,
			// commission: 0,
			// commissionPercent: 0,
		};
		return res;
	}

	async getBank(req: {
		bankID: number;
	}): Promise<IAPIResponse<IBank> | null> {
		//if (!req) return { error: { code: -1, message: "Invalid getAcquirer request" } };
		if (!req) return null;
		const bankID = req.bankID;

		if (bankID === -1) {
			return {
				data: this.generateNewBank(),
			};
		}

		if (this.banks) {
			const f: IBank | undefined = this.banks
				.getData()
				?.find(b => b.id === bankID);
			if (f) {
				return { data: f };
			}
		}

		//!TODO: method;
		const bank = await GD.REQ_API.request({
			method: "bank/get",
			data: {
				id: bankID,
			},
		});

		return bank;
	}

	async saveBank(req: IBank): Promise<IAPIResponse<IBank>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		res = await GD.REQ_API.request({
			method: "bank/add",
			data: {
				id: req.id,
				data: req.data,
			},
		});

		if (res && !res.error) {
			this.banks.reset();
			GD.B_BANKS.invoke(await this.banks.load());
			//  GD.REQ_ACQUIRER.request({acquirerID:req.id})
		}
		return res;
	}
}
